import { indicateWheatType } from '@/modules/common/helpers/wheat-type.helper';
import { IInitialFormState } from '@/modules/seller-account/hooks/use-add-offer.hook';
import {
  createOfferFx,
  fetchBuyerOffersListFx,
} from '@/modules/seller-account/store/offers.store';
import { BuyerInstance } from '@/modules/seller-account/ts';
import { notification } from 'antd';
import { Modal } from 'antd';
import md5 from 'md5';

export const handleCreate = async ({
  date,
  closeFn,
  formState,
  buyerInfo,
  refetchBuyersList,
}: IArgs) => {
  if (!formState.expiryDate)
    return notification.warning({ message: 'Укажите срок действия предложения' });
  Modal.confirm({
    title: 'Подтвердите действие',
    content: `создать предложение с указанной датой истечения ${formState.expiryDate}?`,
    centered: true,
    okText: 'да',
    okButtonProps: { style: { backgroundColor: '#66B28A' } },
    cancelText: 'назад',
    onOk: async () => {
      //const offsetMinutes = new Date().getTimezoneOffset();
      const unixTimestamp =
        new Date(
          date.year,
          date.month - 1,
          date.day,
          date.hours,
          date.minutes,
        ).getTime() /
          1000 
          // - offsetMinutes * 60;
      // console.log(date);
      // console.log(unixTimestamp);
      const res = await createOfferFx({
        year: formState.year,
        gluten: formState.gluten,
        idk: formState.idk,
        clop: formState.clop,
        protein: formState.protein,
        cp: formState.cp,
        nature: formState.nature,
        humidity: formState.humidity,
        weed: formState.weed,
        admixture_other_cereals: formState.admixtureOtherCereals,
        wheat_different_type: formState.wheatDifferentType,
        price: formState.buyingPrice,
        pickup: formState.pickup,
        expiration_offer: String(unixTimestamp),
        buyer_id: String(buyerInfo?.id),
        wheat_class: String(formState.wheatClass),
        wheat_type: String(
          indicateWheatType(String(formState.sort), String(formState.type)),
        ),
      });
      refetchBuyersList && (await refetchBuyersList());
      if ('error' in res) {
        try {
          const errorRes = res as any;
          const errorArray = Object.keys(errorRes?.error?.errors).reduce(
            (result, key) => {
              return result.concat(errorRes.error.errors[key]);
            },
            [],
          );
          if (errorArray && errorArray.length > 0) {
            errorArray.map((item) => notification.error({ message: item }));
            return;
          }
        } catch (err) {
          return notification.error({
            message: 'Непредвиденная ошибка. Попробуйте позже.',
          });
        }
      }
      notification.success({ message: 'Предложение успешно добавлено в систему!' });
      fetchBuyerOffersListFx({
        id: buyerInfo?.id,
        md5: buyerInfo?.type === 'external' ? md5(buyerInfo?.company_name) : undefined,
      });
      closeFn();
    },
    onCancel: () => {
      return;
    },
  });
};

interface IArgs {
  date: {
    year: number;
    month: number;
    day: number;
    hours: number;
    minutes: number;
  };
  closeFn: () => void;
  formState: IInitialFormState;
  buyerInfo: any;
  refetchBuyersList?: () => Promise<BuyerInstance[] | undefined>;
}
